module.exports = __webpack_public_path__ + "img/profile-icon.e8f5a9cc.svg";